import axios from "axios";
import store from "../store/index";

let baseUrl = "";
console.log(window.location.origin);

if (window.location.origin === "http://localhost:8080") {
  baseUrl = "http://127.0.0.1:8000/api/";
  // console.log("this isnt local");
} else if (window.location.origin === "https://clinichmis.co.ke") {
  baseUrl = "https://unit.clinichmis.co.ke/api/";
  // console.log("Port 9100 detected, using that API");
} else if (window.location.origin === "https://menjil.tailaf6d1.ts.net") {
  baseUrl = "https://menjil.tailaf6d1.ts.net:10000/api/";
  // console.log("Port 9100 detected, using that API");
} else if (window.location.origin === "https://medley.aezoradynamics.top") {
  baseUrl = "https://infametro.aezoradynamics.top/api/";
  // console.log("Port 9100 detected, using that API");
} else {
  let hostname = window.location.hostname;
  //baseUrl = `http://${hostname}:8080/api/`;

  // Use current protocol (http or https) dynamically
  let protocol = window.location.protocol; // "http:" or "https:"
  // let hostname = window.location.hostname;
  let port = protocol === "https:" ? "10000" : "8080";

  baseUrl = `${protocol}//${hostname}:${port}/api/`;
}

// let hostname = window.location.hostname;
// let baseUrl = `http://${hostname}:9000/api/`;
// var baseUrl = "https://infametro.aezoradynamics.top/api/";

const token = store.getters.currentToken;

const headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
};

// export async function getMethodRequest(url, data, call_class) {
//   try {
//     const full_url = call_class==1 ? baseUrl+url : url;
//       const response = await axios.get(full_url, {data, headers});
//       return response.data; // Return the fetched data
//   } catch (error) {
//     console.error('Error getting data:', error);
//     return Promise.reject(error); // Reject the promise with the error
//   }
// }

export async function postMethodRequest(url, data, call_class) {
  console.log(window.location.origin);
  try {
    const full_url = call_class == 1 ? baseUrl + url : url;
    const response =
      url == "login"
        ? await axios.post(baseUrl + url, data)
        : await axios.post(full_url, { headers, data });
    return response.data; // Return the fetched data
  } catch (error) {
    console.error("Error fetching data:", error);
    return Promise.reject(error); // Reject the promise with the error
  }
}

function createGetUrl(baseUrl, params) {
  // Check if params is an object
  if (typeof params !== "object" || params === null) {
    throw new Error("params must be a valid object");
  }

  // Build the query string
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join("&");

  // Construct the URL
  const url = `${baseUrl}?${queryString}`;

  if (Object.keys(params).length === 0) {
    return baseUrl;
  } else {
    return url;
  }
}

// export async function generalApiRequest(myurl, method, data, call_class) {
//   const full_url = call_class == 1 ? baseUrl + myurl : myurl;
//   const generated_url =
//     method == "GET" ? createGetUrl(full_url, data) : full_url;

//   const options = {
//     method: method,
//     headers: headers,
//     data: data,
//   };

//   try {
//     const response = await axios(generated_url, options);
//     return { status: "success", data: response.data, code: response.status };
//   } catch (error) {
//     if (error.response) {
//       // Server responded with a status code out of 2xx
//       return {
//         status: "error",
//         data: error.response.data,
//         code: error.response.status,
//       };
//     } else if (error.request) {
//       // No response received
//       return {
//         status: "error",
//         message: "No response received from server",
//       };
//     } else {
//       // Other error (bad config, network etc.)
//       return {
//         status: "error",
//         message: error.message,
//       };
//     }
//   }
// }

export async function generalApiRequest(myurl, method, data, call_class) {
  const full_url = call_class == 1 ? baseUrl + myurl : myurl;

  const generated_url =
    method == "GET" ? createGetUrl(full_url, data) : full_url;
  const options = {
    method: method,
    headers: headers,
    data: data,
  };
  // const response = await axios(generated_url, options); we replace this part below

  // *******************************************************************************************
  // Suppose generated_url already has full URL
  let url = new URL(generated_url);
  // Replace protocol based on client
  url.protocol = window.location.protocol; // "http:" or "https:"
  // Use in axios
  const response = await axios(url.toString(), options);
  //******************************************************************************************** */
  return response.data;
}

export async function generalApiUploadRequest(myurl, data, call_class) {
  const full_url = call_class == 1 ? baseUrl + myurl : myurl;
  //const generated_url = method=="GET" ? createGetUrl(full_url, data) : full_url;
  // console.log("calling");
  const response = await axios.post(full_url, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

export async function generalApiDownloadRequest(
  myurl,
  method,
  data,
  file_name,
  call_class
) {
  const full_url = call_class == 1 ? baseUrl + myurl : myurl;

  const generated_url =
    method == "GET" ? createGetUrl(full_url, data) : full_url;

  try {
    const response = await axios.get(generated_url, {
      method: method,
      headers: {
        Authorization: `Bearer ${token}`, // Include the authentication token
      },
      responseType: "blob",
      data: data,
    });

    // Check if the filename is provided in the response headers
    const contentDisposition = response.headers["content-disposition"];
    let filename = file_name; // Default filename if not provided

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch && filenameMatch.length === 2) {
        filename = filenameMatch[1];
      }
    }

    // Create a blob from the response data
    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });

    // Create a link element
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);

    // Set the filename for the download
    link.setAttribute("download", filename);

    // Append the link to the body and trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    return { message: "success" };
  } catch (error) {
    console.error("Error downloading file:", error);
  }
}
